<app-line-clearance-list
  scrollHeight="540px"
  [fields]="fields"
  [form]="qualityAssuranceForm"
  [hasFocus]="hasFocus"
  [disabled]="disabled"
></app-line-clearance-list>
